export const ADVERTISER_ACL_OBJECTS = [
    'AdvertiserDetail',
    'AdvertiserNew'
];
